
function buildMenu() {
  let children = []

/*  children.push({ name: 'Accueil', url: '/espace-qualite/accueil', icon: 'icon-home' })*/
  children.push({ name: 'Gestion Campagnes', url: '/espace-qualite/campagnes', icon: 'fa fa-list-alt' })
  children.push({ name: 'Gestion Dossiers', url: '/espace-qualite/controle-qualite', icon: 'icon-docs' })
  return children
}
let menu = {
  items: buildMenu(),
}
export default menu
